import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SaveStateData } from 'dbweb-core';
import { RecordViewInnerModule } from './record-view-inner.module';
import { RecordViewComponent } from './record-view.component';

// registerLoadedConfigEvent(CTRL_RECORDVIEW, () => getControllerRoutes(CTRL_RECORDVIEW, RecordViewComponent));
@NgModule({
	imports: [
		RecordViewInnerModule,

		RouterModule.forChild([{ path: '**', data: SaveStateData, component: RecordViewComponent }])
	],
	exports: [RecordViewComponent]
})
export class RecordViewModule {}
